import { createSlice,PayloadAction } from "@reduxjs/toolkit";
import MgpStore from "./Store";

export interface LoginInfoStateDataType {
    LoginInfo: any
}
const initialState:LoginInfoStateDataType  = {
    LoginInfo: null
}

const LoginInfoSlice = createSlice({
    name:"LoginInfoSet",
    initialState,
    reducers: {
        LoginInfoStateChng(state,action:PayloadAction<string>) {
            state.LoginInfo = action.payload;
        }
        ,
        SetNtfyMsgCnt(state, action: PayloadAction<number>) {
            try {
                if (state.LoginInfo && state.LoginInfo.apiBody) {
                    state.LoginInfo.apiBody.ntfyMsgCnt = action.payload;
                }
            } catch (e) {
                // defensive: do nothing if structure unexpected
            }
        },
        SetNickname(state, action: PayloadAction<string>) {
            try {
                if (state.LoginInfo && state.LoginInfo.apiBody) {
                    state.LoginInfo.apiBody.nickname = action.payload;
                }
            } catch (e) {
                // defensive: do nothing if structure unexpected
            }
        }
    }
});
export type AppDispatch = typeof MgpStore.dispatch;
export const {LoginInfoStateChng, SetNtfyMsgCnt, SetNickname} = LoginInfoSlice.actions;
export default LoginInfoSlice.reducer;
